import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import BonusCard from "../DealerBonus/BonusCard";
import { useSelector } from "react-redux";
import { getBonus } from "../../redux/slice/bonusSlice";
import { Checkbox } from "antd";
import { Button } from "@mui/material";
import LoaderComp from "../../components/LoaderComp";
import CommonPopup from "../../components/popup/CommonPopup";

const ChooseBonus = (props) => {
  const { bonusCards } = props;
  const { bonus } = useSelector(getBonus);
  const [selBonus, setSelBonus] = useState([]);
  const handleCheck = (item) => {
    if (selBonus?.length > 0) {
      const iDD = selBonus?.map((it) => it?.id);
      if (iDD?.includes(item?.id)) {
        setSelBonus(selBonus?.filter((it) => it?.id !== item?.id));
      } else {
        setSelBonus(selBonus?.concat(item));
      }
    } else {
      setSelBonus([...selBonus, item]);
    }

  };
  const handleSave = () => {
    props.getSelectBonus(selBonus);
    props.closeBonusPopUp();
  };
  const isChecked = (item) => {
    const selectedIndex = selBonus.findIndex((pd) => pd.id === item.id);
    if (selectedIndex !== -1) {
      return true;
    } else {
      return false;
    }
  };
  useEffect(() => {
    if (bonusCards?.length > 0) {
      setSelBonus(bonusCards);
    }
  }, [bonusCards]);
  // console.log("selBonus", selBonus, bonusCards)
  return (
    <CommonPopup
      size="xlg"
      isOpen={props?.selBonus}
      onClose={() => props.closeBonusPopUp()}
      title="Select Bonus"
    >
      <div className="relative">
        <div>
          <div>
            {bonus.length > 0 ? (
              bonus.map((item, idx) => {
                return (
                  <label
                    htmlFor={`selBns${idx}`}
                    className={`flex items-center gap-[10px] mb-[15px] cursor-pointer ${selBonus.length >= 4 && !isChecked(item) && "diab_lbl"
                      }`}
                    key={idx}
                  >
                    <Checkbox
                      id={`selBns${idx}`}
                      checked={isChecked(item)}
                      onChange={(val) => handleCheck(item)}
                      disabled={selBonus.length >= 4 && !isChecked(item)}
                    />
                    <BonusCard bonus={item} />
                  </label>
                );
              })
            ) : (
              <div className="text-center font-[700] text-[20px] mt-[30px]">
                No Bonuses
              </div>
            )}
            <div className="mt-[25px] pl-[26px]">
              <Button type="button" className="sav_btn" onClick={handleSave}>
                Save Changes
              </Button>
            </div>
          </div>
        </div>
      </div>
    </CommonPopup>
  );
};

export default ChooseBonus;
